import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

const carousel = keyframes`
0%{
    transform: translateY(1rem);
    opacity: .3
}
30% {
    transform: translateY(.5rem);
    opacity: .6
}
60% {
    transform: translateY(0.3rem);
    opacity: .7

}

90% {
    transform: translateY(0.2rem);
    opacity: .9 
}

100% {
    transform: translateY(0.1rem);
    opacity: .9
 
}

`
const AREA = styled.section`
position: fixed;
z-index: 4;
margin-top: 3;
display: flex;
padding-right: .5rem;
padding-left: .5rem;
width: 100%;
 

& p {
    line-height: 2;
    background: green;
    color: white;
    align-self: center;
    margin-left: auto;
    padding: 1rem;
    margin-right: 1rem;
    border-radius: 1rem;
    text-align: left;
     animation ${carousel} 2s;
    animation-timing-function: ease-in-out;
    animation-direction: alternate-reverse;
    
}


`

const AlertMsg = ({msg, action, getSt}) => {

    const[show, setShow] = useState(false)
     
 
 
     useEffect(() => {

        if(action !== 'FINANCE') {
    
            getSt(show)
        }
    })
     

       switch (action) {
                 case 'Quote': return(
                    <AREA style={show ? {display: 'none'} : {display: 'flex'}}>

                    <p>
                    <span onClick={() => setShow(true)}>
        
                    <CancelOutlinedIcon style={{marginLeft:'90%', color:'red', fontWeight:'bold'}} />
                    </span>
                    <br />
                    {msg}                               
                     
        
                    
                </p> 
                    </AREA>
                 )
                case 'FIN_NET_ERR': return(
                    <AREA style={show ? {display: 'none'} : {display: 'flex'}}>

                    <p>
                    <span onClick={() => setShow(true)}>
        
                    <CancelOutlinedIcon style={{marginLeft:'90%', color:'red', fontWeight:'bold'}} />
                    </span>
                    <br />
                    {msg}                               
                    <br />
                        <br />
            
                        <button style={{padding:'.5rem', border:'2px transparent solid', background:'white', color:'black', fontWeight:'normal', outline:'none', boxShadow:'0rem .2rem .2rem silver', cursor:'pointer'}} onClick={() => window.location.reload(true)}>Refresh</button>
        
                    
                </p> 
                    </AREA> 
                )
                case 'FINANCE': return (
                    <AREA style={show ? {display: 'none'} : {display: 'flex'}}>

                    <p>
                    <span onClick={() => setShow(true)}>
        
                    <CancelOutlinedIcon style={{marginLeft:'90%', color:'red', fontWeight:'bold'}} />
                    </span>
                    <br />
                    {msg}                               
                     
        
                    
                </p> 
                    </AREA>

                )
                    
            
                default: return (
                    <AREA style={show ? {display: 'none'} : {display: 'flex'}}>

                        <p>
                        <span onClick={() => setShow(true)}>
            
                        <CancelOutlinedIcon style={{marginLeft:'90%', color:'red', fontWeight:'bold'}} />
                        </span>
                        <br />
                        {msg}                               
                        <br />
                        <br />
            
                        <button style={{padding:'.5rem', border:'2px transparent solid', background:'white', color:'black', fontWeight:'normal', outline:'none', boxShadow:'0rem .2rem .2rem silver', cursor:'pointer'}} onClick={() => window.location.reload(false)}>Refresh</button>
                    </p>
                   
                    </AREA>


                )
                   
            }
            }
       
 
        
 
 
export default AlertMsg;